
import Vue from 'vue'
import { IFilter } from '../store/state'
import Filters from './Filters.vue'

interface AppData {}

interface AppMethods {
    setFilterSearch(event: any): void
    toggleFilter(): void
}

interface AppComputed {
    filters: IFilter[]
    showFilter: boolean
}

interface AppProps {}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
    name: 'FilterWithoutSearch',
    computed: {
        filters() {
            return this.$store.getters.filters
        },
        showFilter() {
            return this.$store.state.showFilter
        }
    },
    methods: {
        setFilterSearch(event: any) {
            const target = event.target
            const id = target.id
            this.$store.dispatch({
                type: 'setFilterSearch',
                payload: id
            })  
        },
        toggleFilter() {
			this.$store.dispatch({
				type: 'setFilterModal',
				payload: this.$store.state.showFilter
			})
		},
    },
    components: {
        Filters
    }
})
